export interface SendGridMReceipt {
  id: string;
  senderEmail: string;
  recipientEmail: string;
  subject: string;
  status: string;
  opens: number;
  clicks: number;
  lastEventTime: string; // ISO
}

export const exampleSendGridMMReceipt: SendGridMReceipt = {
  id: '123',
  senderEmail: 'hello@drivestl.com',
  recipientEmail: 'goodbye@drivestl.com',
  subject: 'hi',
  status: 'idk',
  opens: 1,
  clicks: 2,
  lastEventTime: new Date().toISOString(),
};

export interface SendGridMDetails {
  id: string;
  senderEmail: string;
  subject: string;
  recipientEmail: string;
  status: string;
  events: Array<{
    event_name: string;
    processed: string; // ISO
  }>;
}

export const exampleSendGridMDetails: SendGridMDetails = {
  id: '123',
  senderEmail: 'hello@drivestl.com',
  recipientEmail: 'goodbye@drivestl.com',
  subject: 'hi',
  status: 'idk',
  events: [
    {
      event_name: 'delivered',
      processed: new Date().toISOString(),
    },
  ],
};
